/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  setTimeout(() => {
    document.querySelector('#NavStandard').style.opacity = '1';
  }, 1500);

  // Product card videos don't autoplay (see snippets/grid-media-video.liquid); play them only while hovered
  document.addEventListener('mouseover', (event) => {
    const card = event.target.closest('[data-product-block]');
    if (!card || card.contains(event.relatedTarget)) return;
    card.querySelectorAll('video.media-video--hover').forEach((video) => video.play().catch(() => {}));
  });
  document.addEventListener('mouseout', (event) => {
    const card = event.target.closest('[data-product-block]');
    if (!card || card.contains(event.relatedTarget)) return;
    card.querySelectorAll('video.media-video--hover').forEach((video) => video.pause());
  });

  // Hide the "Ships in..." line while the selected variant is sold out (initial state set in snippets/product.liquid)
  if (typeof subscribe === 'function') {
    subscribe(theme.PUB_SUB_EVENTS.variantChange, (event) => {
      const { sectionId, variant } = event.data;
      const scope = document.getElementById(`shopify-section-${sectionId}`) || document;
      scope.querySelectorAll('[data-ship-info]').forEach((el) => {
        el.hidden = !variant?.available;
      });
    });
  }

  // Cart icon badges (sections/header.liquid): refresh the count after any cart change. The theme re-sets
  // cart__toggle--has-items on the cart icons after every cart render, so that and its cart events trigger it.
  const cartCountBadges = document.querySelectorAll('[data-cart-count]');
  if (cartCountBadges.length) {
    let cartCountTimer;
    const refreshCartCount = () => {
      clearTimeout(cartCountTimer);
      cartCountTimer = setTimeout(() => {
        fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } })
          .then((response) => response.json())
          .then(({ item_count: count }) => {
            cartCountBadges.forEach((badge) => {
              badge.textContent = count > 99 ? '99+' : count;
              badge.hidden = !count;
            });
          })
          .catch(() => {});
      }, 150);
    };
    ['theme:cart:added', 'theme:cart:refresh', 'theme:cart:update', 'theme:cart:loaded'].forEach((name) => {
      document.addEventListener(name, refreshCartCount);
    });
    const cartToggleObserver = new MutationObserver(refreshCartCount);
    document.querySelectorAll('.cart__toggle').forEach((toggle) => {
      cartToggleObserver.observe(toggle, { attributes: true, attributeFilter: ['class'] });
    });
    // Back/forward cache: the page may show an old count.
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) refreshCartCount();
    });
  }

  // Builder bottom bars (Design Your Dream .alx-bar, enamel builder .builder-nav): the Shopify Inbox
  // bubble is lifted above the bar (--bottom-bar-h, see custom.css). The bars sit above the Inbox widget,
  // whose see-through box stays over the buttons, except while its chat window is open (.chat-is-open).
  const hasBottomBar = () => document.querySelector('.alx-bar, .builder-nav');
  const chatWindowOpen = () => {
    const roots = [document.querySelector('shopify-chat')?.shadowRoot];
    while (roots.length) {
      const root = roots.pop();
      if (!root) continue;
      for (const el of root.querySelectorAll('*')) {
        if (el.shadowRoot) roots.push(el.shadowRoot);
        const box = el.getBoundingClientRect();
        if (box.height < window.innerHeight * 0.4 || box.width < Math.min(window.innerWidth * 0.5, 300)) continue;
        const style = getComputedStyle(el);
        if (style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) > 0.1) return true;
      }
    }
    return false;
  };
  // Inbox already lifts its bubble by itself (more in theme preview), so measure where it sits
  // without our transform: --chat-own-lift is its gap to the bottom of the screen.
  const chatActivator = () => {
    const roots = [document.querySelector('shopify-chat')?.shadowRoot];
    while (roots.length) {
      const root = roots.pop();
      if (!root) continue;
      const found = root.querySelector('[part~="activator"]');
      if (found) return found;
      root.querySelectorAll('*').forEach((el) => el.shadowRoot && roots.push(el.shadowRoot));
    }
    return null;
  };
  const syncBottomBar = () => {
    const bar = hasBottomBar();
    if (!bar) return;
    const shown = getComputedStyle(bar).display !== 'none' && !bar.classList.contains('is-hidden');
    document.body.style.setProperty('--bottom-bar-h', `${shown ? Math.round(bar.offsetHeight) : 0}px`);
    const activator = chatActivator();
    if (activator && activator.offsetHeight) {
      const shift = new DOMMatrixReadOnly(getComputedStyle(activator).transform).m42;
      const ownLift = window.innerHeight - (activator.getBoundingClientRect().bottom - shift);
      document.body.style.setProperty('--chat-own-lift', `${Math.max(0, Math.round(ownLift))}px`);
    }
    document.body.classList.toggle('chat-is-open', chatWindowOpen());
  };
  // The bars are built by their own scripts, so check for them a little after load too.
  [0, 1000, 3000].forEach((delay) => setTimeout(syncBottomBar, delay));
  window.addEventListener('resize', syncBottomBar);
  setInterval(() => {
    if (hasBottomBar() && document.querySelector('shopify-chat')) syncBottomBar();
  }, 700);

  const discountSettings = window.siteDiscountSettings;
  if (!discountSettings?.enabled || !discountSettings?.percentage) return;

  subscribe(theme.PUB_SUB_EVENTS.variantChange, function(event) {
    const variant = event.data.variant;
    console.log(variant);
    if (!variant) return;

    const percentageAmount = discountSettings.percentage;
    const regularPrice = variant.price;
    const discountAmount = Math.floor(regularPrice * percentageAmount / 100);
    const finalPrice = regularPrice - discountAmount;

    const formattedFinalPrice = window.theme.formatMoney(finalPrice, theme.moneyFormat);
    const formattedRegularPrice = window.theme.formatMoney(regularPrice, theme.moneyFormat);

    const priceBox = document.querySelector('.product-card-discount-price-box');
    if (!priceBox) return;

    const finalPriceEl = priceBox.querySelector('[data-product-price]');
    const comparePriceEl = priceBox.querySelector('[data-compare-price]');

    if (finalPriceEl) finalPriceEl.innerHTML = formattedFinalPrice;
    if (comparePriceEl) comparePriceEl.innerHTML = formattedRegularPrice;
  });






  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
